import { render, staticRenderFns } from "./SynergismAntimatterDimensionsTab.vue?vue&type=template&id=50df59c7&scoped=true&"
import script from "./SynergismAntimatterDimensionsTab.vue?vue&type=script&lang=js&"
export * from "./SynergismAntimatterDimensionsTab.vue?vue&type=script&lang=js&"
import style0 from "./SynergismAntimatterDimensionsTab.vue?vue&type=style&index=0&id=50df59c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50df59c7",
  null
  
)

export default component.exports